import React, { FC } from 'react'
import { InfinityLoaderProps } from './propsType'
import { Loader, LoaderWrapper } from './styled'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const loader = require('../../gif/loader.gif')

const InfinityLoader: FC<InfinityLoaderProps> = ({ isLoading }) => {
  if (isLoading) {
    return (
      <LoaderWrapper>
        <Loader src={loader} alt="loader" />
      </LoaderWrapper>
    )
  }
  return null
}

export default InfinityLoader
